var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-eye-invisible.3bf763c9.png","uri@2x": __webpack_public_path__ + "icon-eye-invisible.589eaae6.png","uri@3x": __webpack_public_path__ + "icon-eye-invisible.98df7aa5.png",
    width: 61,
    height: 55
});